import React from 'react'
import { TreeSelectProps } from './types'
import SingleTreeSelect from './SingleTreeSelect'
import MultiTreeSelect from './MultiTreeSelect'

const TreeSelectRouter: React.FC<TreeSelectProps> = (props) => {
	return props.multiple ? <MultiTreeSelect {...props} /> : <SingleTreeSelect {...props} />
}

export default TreeSelectRouter
